const estadoInicial = {
    ordenarPor: 'classificar_por',
    total: 0
}

const ordenacaoReducer = (state = estadoInicial, action) => {

    switch (action.type) {
        case 'GET_ORDERNAR_POR':
            return {
                ...state,
                ordenarPor: action.ordenarPor
            }

        case 'SET_TOTAL':
            return {
                ...state,
                total: action.total
            }

        case 'LIMPAR_FILTRO':
            return {
                ...state,
                ordenarPor: 'classificar_por',
                total: 0
            }

        default:
            return state

    }
}

export default ordenacaoReducer